module.exports = __webpack_public_path__ + "img/e1bb90638973f42dc542bb555c7e36d8.svg";